<script>
import { Auth } from 'aws-amplify'
import objectUtils from '../../utils/object-utils'

export default {
  name: 'GoogleOAuth',

  beforeRouteEnter (to, from, next) {
    next(async (vm) => {
      // const { code, state } = vm.$route.query
      console.log('[DEVING] Google callback !', vm.$route.query)
      console.log('[DEVING] to:', to)
      console.log('[DEVING] from:', from)
      try {
        const sessionInfo = await Auth.currentSession()
        // const user = await Auth.currentAuthenticatedUser()
        // const userInfo = await Auth.currentUserInfo()

        console.log('[DEVING] sessionInfo:', sessionInfo)
        // console.log('[DEVING] user:', user)
        // console.log('[DEVING] userInfo:', userInfo)

        if (sessionInfo) {
          const token = objectUtils.get(sessionInfo, 'accessToken.jwtToken', null)
          const tokenExpiresAt = objectUtils.get(sessionInfo, 'accessToken.payload.exp', -1)
          const authInfo = {
            token,
            expires_at: tokenExpiresAt
          }
          if (token) {
            await vm.$store.dispatch('auth/oauthUser', authInfo)
            vm.$router.push({ name: 'home' })
          }
        } else {
          console.log('[DEVING] This is an OAuth logout action !')
        }
      } catch (err) {
        console.error(err)
      }
    })
  },

  render () {
    return null
  }
}
</script>
